<template>
  <v-dialog scrollable v-model="dialog" persistent max-width="500">
    <v-card>
      <v-card-title class="headline">
        {{ $t("headers.contacts.email") }}
      </v-card-title>
      <v-card-text>
        <v-container fluid fill-height>
          <v-flex md12>
            <v-form ref="emailForm" v-model="valid">
              <v-autocomplete
                v-model="recipients"
                :items="emails"
                :label="$t('components.emaildialog.select_recipients')"
                item-text="name"
                item-value="email"
                multiple
                chips
                required
                :rules="[$rules.atLeastOne]"
              >
                <template v-slot:selection="data">
                  <v-chip
                    v-bind="data.attrs"
                    :input-value="data.selected"
                    close
                    @click="data.select"
                    @click:close="removeEmail(data.item)"
                  >
                    {{ data.item.name }}
                  </v-chip>
                </template>
                <template v-slot:item="data">
                  <template>
                    <v-list-item-content>
                      <v-list-item-title
                        v-html="data.item.name"
                      ></v-list-item-title>
                      <v-list-item-subtitle
                        v-html="data.item.email"
                      ></v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>
              <no-autocomplete-textfield
                v-model="subject"
                name="emailSubject"
                disabled="disabled"
                :label="$t('components.emaildialog.subject')"
              >
              </no-autocomplete-textfield>
              <v-textarea
                v-model="innerBody"
                name="emailBody"
                label="Email Body"
              ></v-textarea>
              <v-autocomplete
                v-model="attachments"
                :items="['Pdf', 'Excel']"
                :label="$t('components.emaildialog.select_attachments')"
                multiple
                required
                :rules="[$rules.atLeastOne]"
              >
              </v-autocomplete>
            </v-form>
          </v-flex>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-flex class="text-xs-right">
          <v-btn color="" text @click="close()">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn :disabled="!valid" color="primary" @click="sendEmail()">
            {{ $t("headers.contacts.email") }}
          </v-btn>
        </v-flex>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield";
export default {
  name: "email-dialog",
  props: ["emails", "dialog", "subject", "body"],
  components: { NoAutocompleteTextfield },
  data() {
    return {
      innerBody: "",
      valid: true,
      recipients: [],
      attachments: [],
    };
  },
  computed: {
    ...mapGetters("common", ["messages"]),
  },
  methods: {
    removeEmail(item) {
      const index = this.recipients.indexOf(item.email);
      if (index >= 0) this.recipients.splice(index, 1);
    },
    sendEmail() {
      this.$emit("sendmail", {
        email: {
          body: this.innerBody,
          subject: this.subject,
          recipients: this.recipients,
        },
        attachments: this.attachments,
      });
      this.$emit("dialog-set", false);
      this.recipients = [];
      this.attachments = [];
      this.$refs.emailForm.resetValidation();
    },
    close() {
      this.$emit("dialog-set", false);
      this.recipients = [];
      this.attachments = [];
      this.$refs.emailForm.resetValidation();
    },
  },
  watch: {
    body: {
      handler(v) {
        this.innerBody = v;
      },
      immediate: true,
    },
  },
};
</script>
